import {NewEntityVotingModel} from "@/entities/voting/NewEntityVotingModel";
import {VotingType} from "@/entities/voting/VotingType";
import {AnswerType} from "@/entities/questionaire/answers/AnswerType";

export class NewAttributeVotingModel extends NewEntityVotingModel {
    type: VotingType = VotingType.addQuestion;
    newQuestion: {
        groupId: number;
        question: string;
        answerType: AnswerType;
        answerVariants: {text: string}[] | null;
    };


    constructor(branchId: number, groupId: number, question: string, answerType: AnswerType, answerVariants: {text: string}[] | null) {
        super(branchId);

        this.newQuestion = {
            groupId: groupId,
            question: question,
            answerType: answerType,
            answerVariants: answerVariants,
        };
    }
}
